import { Injectable } from "@angular/core";
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";

@Injectable({
    providedIn: "root",
})
export class NotificacionesService {
    private durationInSeconds = 3;
    private horizontalPosition: MatSnackBarHorizontalPosition = "right";
    private verticalPosition: MatSnackBarVerticalPosition = "top";

    constructor(private _snackBar: MatSnackBar) {}

    mostrarNotificacion(mensaje: string, tipo: "success" | "error" | "info") {
        // const panelClass =
        //     tipo === "success"
        //         ? "light-green-700"
        //         : "error"
        //         ? "red-700"
        //         : "orange-700";

        let panelClass: string;
        switch (tipo) {
            case "success":
                panelClass = "light-green-700";
                break;
            case "error":
                panelClass = "red-700";
                break;
            case "info":
                panelClass = "light-blue-700";
                break;
            default:
                panelClass = "grey-700";
                break;
        }

        this._snackBar.open(mensaje, null, {
            duration: this.durationInSeconds * 1000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass,
        });
    }
}
